export const CADASTRO_TITULOS = {
  VISTORIADOR: 'vistoriador',
  GEOMENSOR: 'geomensor'
}

export const CADASTRO_SUBTITULOS = {
  aviso: 'Confira os documentos e informações necessários antes de iniciar a solicitação.',
  formulario: 'Preencha os dados abaixo para realizar o cadastro'
}

export const CADASTRO_ALERTA_AVISO = {
  titulo: 'Antes de iniciar',
  descricao: 'Reúna os documentos e informações listados abaixo. Você poderá anexar arquivos e preencher os dados na etapa seguinte da solicitação.'
}

/**
 * Documentos obrigatórios por tipo de cadastro (tela de aviso e envio no formulário).
 * Os códigos devem existir na API de tipoDocumentoCredenciado.
 */
export const CADASTRO_DOCUMENTOS_POR_TIPO = {
  VISTORIADOR: [
    {
      codigo: 'DOCUMENTO_IDENTIFICACAO',
      titulo: 'Documento de identificação',
      obrigatorio: true
    },
    {
      codigo: 'CERTIDAO_ATRIBUICAO_ORGAO_CLASSE',
      titulo: 'Certidão de atribuição no órgão de classe',
      obrigatorio: true
    },
    {
      codigo: 'CERTIDAO_QUITACAO_ORGAO_CLASSE_E_CERTIDAO_REGISTRO_ORGAO_CLASSE',
      titulo: 'Certidão de quitação no órgão de classe e certidão de registro no órgão de classe',
      obrigatorio: true
    },
    {
      codigo: 'FOTO_PERFIL',
      titulo: 'Foto de perfil',
      obrigatorio: true
    }
  ],
  GEOMENSOR: [
    {
      codigo: 'DOCUMENTO_IDENTIFICACAO',
      titulo: 'Documento de identificação',
      obrigatorio: true
    },
    {
      codigo: 'COMPROVANTE_INCRA',
      titulo: 'Comprovante de credenciamento do INCRA',
      obrigatorio: true
    },
    {
      codigo: 'CERTIDAO_ATRIBUICAO_ORGAO_CLASSE',
      titulo: 'Certidão de atribuição no órgão de classe',
      obrigatorio: true
    },
    {
      codigo: 'CERTIDAO_QUITACAO_ORGAO_CLASSE_E_CERTIDAO_REGISTRO_ORGAO_CLASSE',
      titulo: 'Certidão de quitação no órgão de classe e certidão de registro no órgão de classe',
      obrigatorio: true
    },
    {
      codigo: 'CONSULTA_PENALIDADE_INCRA_SIGEF',
      titulo: 'Consulta de penalidade no INCRA/SIGEF',
      obrigatorio: true
    },
    {
      codigo: 'FOTO_PERFIL',
      titulo: 'Foto de perfil',
      obrigatorio: true
    }
  ]
}

export function getDocumentosAviso (tipoCadastro) {
  return CADASTRO_DOCUMENTOS_POR_TIPO[tipoCadastro] || []
}

/**
 * Filtra os tipos retornados pela API, mantendo só os documentos do tipo de cadastro + Outros.
 * Usa o título definido no front para exibição consistente na tela de aviso e no formulário.
 */
export function filtrarTiposDocumentosPorCadastro (tiposApi, tipoCadastro) {
  const definicoes = CADASTRO_DOCUMENTOS_POR_TIPO[tipoCadastro] || []
  const porCodigo = {}

  tiposApi.forEach(tipo => {
    porCodigo[tipo.codigo] = tipo
  })

  const obrigatorios = definicoes
    .map(definicao => {
      const tipo = porCodigo[definicao.codigo]
      if (!tipo) return null
      return {
        ...tipo,
        descricao: definicao.titulo
      }
    })
    .filter(Boolean)

  const outros = porCodigo.OUTROS
  const tipos = outros ? [...obrigatorios, outros] : [...obrigatorios]

  return { tipos, obrigatorios }
}

export const CADASTRO_AVISO_INFORMACOES = [
  {
    titulo: 'Tipo de serviço',
    obrigatorio: true,
    descricao: 'Resgate de aforamento ou transferência de direitos (laudêmio).'
  },
  {
    titulo: 'Dados do cadastrante',
    obrigatorio: true
  },
  {
    titulo: 'Dados do interessado',
    obrigatorio: true,
    descricao: 'Inclui sócios quando pessoa jurídica.'
  }
]

export const CADASTRO_SECOES = {
  dadosPessoais: 'Dados pessoais',
  formacao: 'Formação',
  endereco: 'Endereço',
  documentacao: 'Documentação'
}

export const CADASTRO_FORMATOS_DOCUMENTO = 'doc, docx, jpeg, jpg, pdf, png · Máx. 20MB'

/** Extensões aceitas para documentos (exceto foto de perfil). */
export const CADASTRO_EXTENSOES_DOCUMENTO = [
  'pdf', 'rar', 'zip', 'png', 'jpg', 'jpeg', 'doc', 'docx'
]

/** Extensões aceitas quando o tipo selecionado é foto de perfil. */
export const CADASTRO_EXTENSOES_FOTO_PERFIL = ['png', 'jpg', 'jpeg', 'heic']

/** Extensões do upload no cadastro público (tipo é escolhido depois do arquivo). */
export const CADASTRO_EXTENSOES_UPLOAD = [
  ...new Set([...CADASTRO_EXTENSOES_DOCUMENTO, ...CADASTRO_EXTENSOES_FOTO_PERFIL])
]

export const TERMO_COMPROMISSO_INTRO =
  'Ao prosseguir com o credenciamento junto ao Instituto de Terras do Pará – ITERPA, declaro que li, compreendi e concordo com as disposições abaixo.'

function itensCompromissoProfissional (tipoCadastro) {
  const isGeomensor = tipoCadastro === 'GEOMENSOR'
  const servico = isGeomensor ? 'georreferenciamento' : 'vistoria'
  const comite = isGeomensor
    ? 'Comitê para Análise de Georreferenciamento (CAGeo/ITERPA)'
    : 'Comitê para Análise de Vistoria (CA-Vistoria/ITERPA)'

  return [
    `atuar na qualidade de profissional credenciado pelo ITERPA, desempenhando os serviços técnicos de ${servico} e demais atividades relacionadas à regularização fundiária em conformidade com a legislação vigente, observando os princípios da legalidade, boa-fé, ética e responsabilidade profissional;`,
    'responder civil, administrativa e criminalmente pelos atos praticados no exercício das atividades decorrentes do credenciamento;',
    `cumprir integralmente as normas legais, regulamentares e técnicas aplicáveis, bem como as orientações, procedimentos e deliberações estabelecidos pelo ${comite};`,
    'não utilizar marcas, símbolos, logotipos ou qualquer identidade visual oficial do ITERPA ou do Governo do Estado do Pará de forma que possa induzir terceiros a erro ou sugerir vínculo diverso daquele decorrente do credenciamento;',
    'divulgar minha condição de profissional credenciado de forma ética e discreta, abstendo-me de práticas que caracterizem concorrência desleal ou captação indevida de clientes;',
    'declarar que todas as informações, documentos e declarações apresentados durante o processo de credenciamento são verdadeiros, completos e atualizados, assumindo integral responsabilidade por sua veracidade.'
  ]
}

export function getSecoesTermoCompromisso (tipoCadastro) {
  return [
    {
      titulo: '1. Compromisso Profissional',
      intro: 'Comprometo-me a:',
      itens: itensCompromissoProfissional(tipoCadastro)
    },
    {
      titulo: '2. Autorização para Divulgação de Contatos Profissionais',
      paragrafos: [
        'Estou ciente de que o ITERPA mantém uma relação pública de profissionais credenciados, com a finalidade de facilitar o contato entre cidadãos interessados em procedimentos de regularização fundiária e profissionais habilitados para execução de serviços técnicos.',
        'Dessa forma, autorizo a divulgação dos seguintes canais de contato profissional na página institucional do ITERPA:'
      ]
    },
    {
      titulo: '3. Ciência sobre a Divulgação',
      paragrafos: [
        'Declaro estar ciente de que os canais de contato autorizados poderão ser disponibilizados em página institucional do ITERPA, de acesso público, exclusivamente para permitir que interessados em procedimentos de regularização fundiária possam localizar e entrar em contato com profissionais devidamente credenciados.'
      ]
    },
    {
      titulo: '4. Finalidade de Uso dos Dados',
      paragrafos: [
        'Estou ciente de que os dados de contato autorizados serão utilizados exclusivamente para as seguintes finalidades:'
      ],
      itens: [
        'atualização da página institucional de profissionais credenciados;',
        'facilitar o contato entre interessados e profissionais credenciados;',
        'organização e manutenção da relação de profissionais credenciados, incluindo nome, região de atuação e canais de contato autorizados;',
        'apoio operacional às atividades e procedimentos de regularização fundiária que demandem atuação de profissionais credenciados;',
        'registro da autorização concedida para fins administrativos.'
      ]
    },
    {
      titulo: '5. Declaração Final',
      paragrafos: [
        'Declaro que li, compreendi e concordo integralmente com todas as disposições deste Termo.',
        'Declaro, ainda, que as informações prestadas durante o processo de credenciamento são verdadeiras e que assumo total responsabilidade por sua veracidade, bem como autorizo, de forma livre, informada e inequívoca, a divulgação dos canais de contato profissional por mim assinalados, exclusivamente para as finalidades previstas neste documento.'
      ]
    }
  ]
}

export const DIVULGACAO_CONTATO_OPCOES = [
  {
    valor: 'EMAIL_TELEFONE',
    label: 'Autorizo a divulgação do meu e-mail e telefone profissionais.',
    descricao: 'Ambos os canais ficarão visíveis na página institucional do ITERPA.'
  }
]
